<template>
  <component :is="workerData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="workerData === undefined">
      <h4 class="alert-heading">獲取師傅數據時出錯</h4>
      <div class="alert-body">
        找不到相關師傅記錄。請查看
        <b-link class="alert-link" :to="{ name: 'workers-list' }">
          師傅名單
        </b-link>
      </div>
    </b-alert>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fa-solid fa-person-digging" />
        <span class="ml-1">上傳文件</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <b-tabs pills>
            <b-tab title="師傅資料">
              <worker-edit-tab-information
                v-if="workerData"
                :gender-options="genderOptions"
                :bank-options="bankOptions"
                :payment-method-status-options="paymentMethodStatusOptions"
                :worker-data="workerData"
                @refetch-data="refetchData"
                @onSubmit="onSubmit"
                class="p-sm-2"
              />
              <!-- @onSubmit="onSubmit" -->
            </b-tab>
            <b-tab title="上傳文件">
              <worker-image-upload
                v-if="workerData"
                :worker-data="workerData"
                @refetch-data="refetchData"
                @onSubmit="onSubmit"
              />
            </b-tab>
          </b-tabs>
          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </component>
</template>

<script>
import {
  BCard,
  BAlert,
  BLink,
  BTabs,
  BTab,
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import router from "@/router";
import workerStoreModule from "../workerStoreModule";
import WorkerEditTabInformation from "./workerEditTabInformation.vue";
import workerImageUpload from "./worker-image-upload.vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";

export default {
  components: {
    WorkerEditTabInformation,
    workerImageUpload,
    BCard,
    BAlert,
    BLink,
    BTabs,
    BTab,
    BRow,
    BCol,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BButton,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  methods: {
    hide() {
      this.$router.replace("/workers/list");
    },
    onSubmit() {
      console.log(1)
      /*   if (
        this.idError ||
        (this.workerData.id == 0 && this.workerData.documents)
      )
        return; */
      if (this.idError || this.errorEmailMessage || this.errorPhoneMessage)
        return;

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();

          this.workerData.documents = [
            this.workerData.id_card_image, 
            this.workerData.registration_certificate_image_front, 
            this.workerData.registration_certificate_image_back, 
            this.workerData.safety_training_certificate_image, 
          ].filter(item => item !== null && item !== undefined);

          formData.append("id", this.workerData.id);
          formData.append("is_active", this.workerData.is_active ? 1 : 0);
          formData.append("name_cn", this.workerData.name_cn);
          if(this.workerData.name){
            formData.append("name", this.workerData.name);
          }
          if(this.workerData.registration_certificate_number){
            formData.append(
            "registration_certificate_number",
              this.workerData.registration_certificate_number
            );
          }
          if (this.workerData.safety_training_certificate_number) {
              formData.append(
                "safety_training_certificate_number",
              this.workerData.safety_training_certificate_number
            );
          }
          formData.append("gender_id", this.workerData.gender_id);
          formData.append("id_number", this.workerData.id_number);
          if(this.workerData.date_of_birth){
            formData.append("date_of_birth", this.workerData.date_of_birth);
          }
          if(this.workerData.address){
            formData.append("address", this.workerData.address);
          }
          formData.append("phone", this.workerData.phone);
          if(this.workerData.bank_id){
            formData.append(
              "bank_id",
            this.workerData.bank_id ? this.workerData.bank_id : undefined
          );
          }
          if(this.workerData.bank_account){
              formData.append(
                "bank_account",
              this.workerData.bank_account
                ? this.workerData.bank_account
                : undefined
            );
          }
          if(this.workerData.bank_account_name){
            formData.append("bank_account_name", this.workerData.bank_account_name);
          }
          if(this.workerData.department){
            formData.append("department", this.workerData.department);
          }
            formData.append("join_date", this.workerData.join_date);
          
            formData.append(
            "payment_method_id",
            this.workerData.payment_method_id
          );
          if(this.workerData.position){
            formData.append("position", this.workerData.position);
          }

          if(this.workerData.email){
            formData.append("email", this.workerData.email);
          }
          if (this.workerData.id == 0) {
            formData.append("password", this.workerData.password);
            formData.append(
              "password_confirmation",
              this.workerData.password_confirmation
            );
          }
          if (
            this.workerData.documents &&
            this.workerData.documents.length > 0
          ) {
            this.workerData.documents.forEach((item) => {
              formData.append("documents[]", item);
            });
          }
          // formData.append("documents", this.workerData.id_card_image);
          // formData.append("documents", this.workerData.registration_certificate_front);
          // formData.append("documents", this.workerData.registration_certificate_back);
          // formData.append("documents", this.workerData.safety_training_certificate);

          this.loading = true;

          //   })

          // ])

          (this.workerData.registration_certificate_number != null
            ? store.dispatch("worker/checkRegistrationCertificateNumber", {
                id: this.workerData.id,
                registration_certificate_number:
                  this.workerData.registration_certificate_number,
              })
            : Promise.resolve()
          )
            .then(() => {
              if (this.workerData.safety_training_certificate_number != null) {
                return store.dispatch("worker/checkSafetyTrainingCertificateNumber", {
                  id: this.workerData.id,
                  safety_training_certificate_number:
                    this.workerData.safety_training_certificate_number,
                });
              }
            })
            .then(() => {
              store.dispatch("app/checkUserNameCn", {
                id: this.workerData.id,
                name_cn: this.workerData.name_cn,
              });
            })
            .then(() => {
              store.dispatch("app/checkUserPhone", {
                id: this.workerData.id,
                phone: this.workerData.phone,
              });
            })
            .then(() => {
              if (this.workerData.email) {
                return store.dispatch("app/checkUserEmail", {
                  id: this.workerData.id,
                  email: this.workerData.email,
                });
              }
            })
            .then(() => {
              // 只有在 checkUserPhone 成功後才執行 addCustomer
              return store.dispatch("worker/editWorker", formData);
            })
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(
                  error.response?.data?.message || error.message
                ),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const workerData = ref({ id: 0 });
    const worker = {
      id: 0,
      is_active: 0,
    };

    const WORKER_APP_STORE_MODULE_NAME = "worker";

    if (!store.hasModule(WORKER_APP_STORE_MODULE_NAME))
      store.registerModule(WORKER_APP_STORE_MODULE_NAME, workerStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(WORKER_APP_STORE_MODULE_NAME))
        store.unregisterModule(WORKER_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "worker-create") {
        workerData.value = worker;
      } else {
        store
          .dispatch("worker/fetchWorker", { id: router.currentRoute.params.id })
          .then((response) => {
            workerData.value = response.data.entity;
            if(workerData.value.documents) {
              workerData.value.id_card_image = workerData.value.documents.find(item => item.name === '⾝份証明⽂件') || null;
              workerData.value.registration_certificate_image_front = workerData.value.documents.find(item => item.name === '工人註冊証正面') || null;
              workerData.value.registration_certificate_image_back = workerData.value.documents.find(item => item.name === '工人註冊証背面') || null;
              workerData.value.safety_training_certificate_image = workerData.value.documents.find(item => item.name === '建造業安全訓練證明書') || null;
            }
            console.log(workerData.value);
          })
          .catch((error) => {
            console.log("error when fetching worker", error);
            if (error.response.status === 404) {
              workerData.value = undefined;
            }
          });
      }
    };

    const genderOptions = ref([]);
    const bankOptions = ref([]);
    const paymentMethodStatusOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          genders: true,
          banks: true,
          payment_methods: true,
        })
        .then((response) => {
          genderOptions.value = response.data.genders;
          bankOptions.value = response.data.banks;
          paymentMethodStatusOptions.value = response.data.payment_methods;
        });
    };
    const resetWorkData = () => {
      workerData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };

    const loading = ref(false);
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    onMounted(() => {
      refetchData();
      refetchOption();
    });

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      workerData,
      genderOptions,
      bankOptions,
      paymentMethodStatusOptions,
      refetchData,
      refetchOption,
    };
  },
};
</script>

